// Copy-only homepage refresh plus non-destructive screenshot viewport cropping.
// The established VinCentrix visual system, layout, colors, typography, spacing,
// imagery, and component styling remain unchanged.

const replacements = new Map([
  ['Turn Your Service DriveInto Your #1 Sales Source', 'Turn Customer OpportunitiesInto Vehicles You Want to Own'],
  ['Stop losing service customers to competitors. VinCentrix AI reaches 100% of your service drive, converts 20%+, and delivers hot leads to your sales team.', 'VinCentrix is the vehicle acquisition operating system built to help dealerships identify opportunities, engage owners, work appraisals and offers, acquire vehicles, and measure what happens after the purchase.'],
  ['Request a Demo', 'See VinCentrix in Action'],
  ['What Better Service DriveAcquisition Looks Like', 'A Better Way to RunVehicle Acquisition'],
  ['Never Miss a Customer', 'Know Who to Work Today'],
  ['AI responds within minutes, 24/7. Every service customer gets contacted automatically, ensuring no opportunity slips through the cracks.', 'VC // TODAY, work queues, and acquisition stages help your team see which opportunities need attention, what is missing, and what should happen next.'],
  ['10x Your Conversions', 'Work Every Acquisition Opportunity'],
  ['From 2% to 20%+ capture rate. Industry-leading conversion rates that turn your service drive into a revenue engine.', 'Move opportunities from first contact through appraisal, offer, appointment, acquisition, and follow-up in one acquisition-focused workflow.'],
  ['Automated Pipeline', 'Acquisition Pipeline'],
  ['From text to appointment to sale. Complete automation that handles the entire customer journey from first contact to acquisition.', 'Manage the acquisition journey from opportunity to negotiation to acquired vehicle, with Sydney assisting conversations and follow-up along the way.'],
  ['AI-Powered Engagement', 'Sydney AI Engagement'],
  ['Sydney bot automatically reaches out to every service customer with personalized trade-in offers. Natural conversations, intelligent responses, and seamless handoffs to your team when needed.', 'Sydney helps your acquisition team engage vehicle owners, continue conversations, identify intent, and move interested customers toward the next acquisition step.'],
  ['100% service customer coverage', 'Automated acquisition outreach'],
  ['Personalized offers using VIN & service history', 'Vehicle and customer context in one workflow'],
  ['Natural conversation handling', 'AI-assisted two-way conversations'],
  ['Automatic escalation to sales team', 'Clear handoff when your team should step in'],
  ['Real-Time Analytics', 'Acquisition Intelligence'],
  ['Track acquisition rates, conversions, and team performance with detailed insights. Make data-driven decisions to optimize your acquisition process.', 'See acquisition activity, source performance, realized gross, turn time, and the vehicle segments producing the strongest results for your dealership.'],
  ['Live acquisition metrics', 'Acquisition performance metrics'],
  ['Conversion tracking', 'Source and stage tracking'],
  ['Team performance insights', 'Acquired-to-sold performance'],
  ['Revenue analytics', 'Gross and turn-time intelligence'],
  ['Compliant Messaging', 'Built for Acquisition Teams'],
  ['Full TCPA compliance built-in. Automatic opt-out handling, consent management, and compliance monitoring to keep you protected.', 'VinCentrix gives acquisition teams a dedicated place to manage vehicle owners, conversations, appraisals, offers, next actions, and acquisition outcomes alongside the systems they already use.'],
  ['TCPA compliant', 'Vehicle-first acquisition records'],
  ['Automatic opt-out handling', 'Conversation and activity history'],
  ['Consent management', 'Appraisal and offer workflow'],
  ['Compliance monitoring', 'Acquisition closeout and results tracking'],
  ['Choose Your Plan', 'Pricing Built Around Your Dealership'],
  ["Custom pricing tailored to your dealership's needs. Contact us for a personalized quote.", 'VinCentrix is configured around your rooftop, acquisition workflow, and operating needs. Talk with us for dealership pricing and pilot options.'],
  ['Starter', 'Single Rooftop'],
  ['Perfect for small dealerships', 'For dealerships building a dedicated acquisition process'],
  ['Professional', 'Acquisition OS'],
  ['Ideal for growing dealerships', 'The complete VinCentrix acquisition workflow'],
  ['Most Popular', 'Recommended'],
  ['Enterprise', 'Dealer Group'],
  ['For high-volume dealerships', 'For multi-rooftop acquisition operations'],
  ['The Numbers Don\'t Lie', 'Know What Your Acquisitions Actually Produce'],
  ['Service Customers', 'Opportunity'],
  ['Acquisition Deals', 'Acquired'],
  ['Additional Revenue', 'Sold + Measured'],
  ['Average dealership results per month with VinCentrix', 'Track the full lifecycle: Opportunity → Negotiation → Acquired → Inventory → Sold → Profitability'],
  ['Ready to Transform Your Service Drive?', 'Ready to Build a Better Acquisition Operation?'],
  ['Join 500+ dealerships capturing more service customers and increasing acquisition revenue.', 'See how VinCentrix can fit alongside your existing CRM, DMS, appraisal, and inventory tools to give your team a dedicated operating system for vehicle acquisition.']
]);

const featureReplacements = new Map([
  ['Up to 500 customers', 'Acquisition CRM and pipeline'], ['2 user accounts', 'Ready and Needs Review queues'],
  ['Basic AI engagement', 'Sydney AI engagement'], ['Email support', 'Acquisition performance tracking'],
  ['Up to 2,000 customers', 'VC // TODAY priority workspace'], ['5 user accounts', 'Working and negotiation queues'],
  ['AI engagement', 'Sydney AI engagement'], ['Advanced analytics', 'Acquired-to-sold intelligence'],
  ['Priority support', 'Dealership-specific configuration'], ['Custom branding', 'Unlimited team collaboration'],
  ['Unlimited customers', 'Multi-rooftop acquisition operations'], ['Unlimited users', 'Unlimited team collaboration'],
  ['Custom analytics', 'Source, gross, and turn intelligence'], ['Dedicated support', 'Dealer-group configuration'],
  ['API access', 'Integration-ready architecture'], ['White-label option', 'Centralized acquisition visibility']
]);

const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();

const cropLegacyHomepageScreenshots = () => {
  const crops = {
    '/images/dashboard.png': 0.115,
    '/images/simulator.png': 0.105,
    '/images/analytics.png': 0.105,
    '/images/customers.png': 0.105,
    '/images/appointments.png': 0.105
  };

  document.querySelectorAll('img').forEach(img => {
    const src = img.getAttribute('src');
    if (!(src in crops) || img.dataset.vcHomepageCropped === '1') return;

    const crop = () => {
      if (!img.naturalWidth || !img.naturalHeight) return;
      const ratio = crops[src];
      const visibleHeight = img.naturalHeight * (1 - ratio);
      const renderedWidth = img.getBoundingClientRect().width || img.clientWidth || 600;
      const renderedHeight = renderedWidth * (visibleHeight / img.naturalWidth);

      const frame = document.createElement('div');
      frame.dataset.vcHomepageScreenshotFrame = '1';
      frame.style.width = '100%';
      frame.style.maxWidth = img.style.maxWidth || '1200px';
      frame.style.height = `${renderedHeight}px`;
      frame.style.overflow = 'hidden';
      frame.style.borderRadius = img.style.borderRadius || '12px';
      frame.style.boxShadow = img.style.boxShadow || 'none';
      frame.style.flexShrink = '0';

      img.parentNode.insertBefore(frame, img);
      frame.appendChild(img);
      img.dataset.vcHomepageCropped = '1';
      img.style.width = '100%';
      img.style.maxWidth = 'none';
      img.style.height = 'auto';
      img.style.borderRadius = '0';
      img.style.boxShadow = 'none';
      img.style.transform = `translateY(-${ratio * 100}%)`;
      img.style.transformOrigin = 'top center';
    };

    if (img.complete) crop(); else img.addEventListener('load', crop, { once: true });
  });
};

const resizeScreenshotFrames = () => {
  document.querySelectorAll('[data-vc-homepage-screenshot-frame="1"]').forEach(frame => {
    const img = frame.querySelector('img[data-vc-homepage-cropped="1"]');
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    const src = img.getAttribute('src');
    const ratios = {'/images/dashboard.png':.115,'/images/simulator.png':.105,'/images/analytics.png':.105,'/images/customers.png':.105,'/images/appointments.png':.105};
    const ratio = ratios[src] || .105;
    const w = frame.getBoundingClientRect().width;
    frame.style.height = `${w * ((img.naturalHeight * (1-ratio)) / img.naturalWidth)}px`;
  });
};

const applyCopy = () => {
  if (window.location.pathname !== '/' && window.location.pathname !== '') return;
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node => {
    const current = normalize(node.nodeValue);
    if (!current) return;
    const direct = replacements.get(current) || featureReplacements.get(current);
    if (direct) node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), direct);
  });

  [...document.querySelectorAll('h1')].forEach(h1 => {
    if (/Turn Your Service Drive/i.test(h1.textContent) && /#1 Sales Source/i.test(h1.textContent)) {
      const textNodes = [...h1.childNodes].filter(n => n.nodeType === Node.TEXT_NODE);
      if (textNodes[0]) textNodes[0].nodeValue = 'Turn Customer Opportunities';
      if (textNodes[1]) textNodes[1].nodeValue = 'Into Vehicles You Want to Own';
    }
  });
  [...document.querySelectorAll('h2')].forEach(h2 => {
    if (/What Better Service Drive/i.test(h2.textContent) && /Acquisition Looks Like/i.test(h2.textContent)) {
      const textNodes = [...h2.childNodes].filter(n => n.nodeType === Node.TEXT_NODE);
      if (textNodes[0]) textNodes[0].nodeValue = 'A Better Way to Run';
      if (textNodes[1]) textNodes[1].nodeValue = 'Vehicle Acquisition';
    }
  });

  const smsHeading = [...document.querySelectorAll('h2')].find(el => /Exclusive Vehicle Offers via SMS/i.test(el.textContent));
  if (smsHeading) smsHeading.parentElement.style.display = 'none';

  const numbersHeading = [...document.querySelectorAll('h2')].find(el => /Know What Your Acquisitions Actually Produce|The Numbers Don.t Lie/i.test(el.textContent));
  const roiSection = numbersHeading?.closest('section');
  if (roiSection) {
    const bigValues = [...roiSection.querySelectorAll('div')].filter(el => {
      const s = window.getComputedStyle(el);
      return parseFloat(s.fontSize) >= 40 && ['500','100','$250K'].includes(normalize(el.textContent));
    });
    ['IDENTIFY','ACQUIRE','MEASURE'].forEach((value,i) => { if (bigValues[i]) bigValues[i].textContent = value; });
  }

  cropLegacyHomepageScreenshots();
};

let scheduled = false;
const schedule = () => {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => { scheduled = false; applyCopy(); });
};

new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
window.addEventListener('load', schedule);
window.addEventListener('popstate', schedule);
window.addEventListener('resize', resizeScreenshotFrames);
document.addEventListener('DOMContentLoaded', schedule, { once: true });
setTimeout(schedule, 150);
setTimeout(schedule, 800);
